import React from "react";
import Logo from "@/components/Logo";
import SEO from "@/components/SEO";
import { Link } from "react-router-dom";

export default function About() {
  return (
    <div className="container-x py-16 max-w-4xl" data-testid="about-page">
      <SEO title="About AdiYogi Handcrafts — Karnataka Government Initiative" description="AdiYogi Handcrafts is a Karnataka Government initiative promoting traditional craftsmanship, spiritual products and handcrafted creations — Brass, Bronze, German Silver and Rudraksha for pooja, home & temple." />
      <div className="flex flex-col md:flex-row items-center md:items-start gap-8 md:gap-12 mb-12">
        <Logo size="lg" linkTo={null} />
        <div>
          <div className="flex flex-wrap items-center gap-2 text-xs uppercase tracking-[0.3em] text-muted-foreground mb-3">
            <span>Our Story</span>
            <span className="text-[#B8860B]">·</span>
            <span className="inline-flex items-center gap-1 rounded-full border hairline px-2.5 py-0.5 text-[10px] tracking-[0.2em] text-espresso bg-white" data-testid="karnataka-badge-about">
              <span aria-hidden="true">🇮🇳</span> Karnataka Government Initiative
            </span>
          </div>
          <h1 className="font-serif text-4xl md:text-5xl leading-tight">
            Craftsmanship for your <span className="gold-text italic">sacred spaces.</span>
          </h1>
        </div>
      </div>

      <div className="border hairline rounded-xl p-5 md:p-6 bg-muted/40 mb-10 flex items-start gap-4" data-testid="karnataka-panel">
        <div className="w-10 h-10 shrink-0 rounded-full border border-[#B8860B] flex items-center justify-center text-lg" aria-hidden="true">🇮🇳</div>
        <div>
          <div className="font-serif text-lg mb-1">Karnataka Government Initiative</div>
          <div className="text-sm text-muted-foreground">
            AdiYogi Handcrafts is a Karnataka Government initiative dedicated to promoting traditional
            craftsmanship, spiritual products and meaningful handcrafted creations.
          </div>
        </div>
      </div>

      <div className="prose prose-sm text-muted-foreground space-y-4 max-w-none">
        <p>
          AdiYogi Handcrafts brings together beautifully made Brass, Bronze, German Silver and Rudraksha
          pieces for pooja, home temples, housewarming rituals and thoughtful spiritual gifting.
        </p>
        <p>
          Every piece we bring to you is chosen with attention to detail — the weight of the metal,
          the finish of the diya, the resonance of a temple bell, the character of a hand-strung mala.
          We work only with items that meet our standards for material, form and finish.
        </p>
        <p>
          Whether it&rsquo;s a small brass diya for daily aarti, a Ganesha idol for a new home, or
          a complete Griha Pravesh kalash set — we hope our handcrafts help make your sacred moments
          feel a little more beautiful.
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-6 mt-14">
        {[
          { t: "Attention to Craft", b: "Materials, finishing and packaging are chosen so each piece feels heirloom-worthy." },
          { t: "Made for Ritual", b: "Curated for daily aarti, festivals, housewarming and thoughtful spiritual gifting." },
          { t: "Delivered with Care", b: "Secure packaging, all-India delivery and international shipping — with prepaid UPI checkout." },
        ].map((v) => (
          <div key={v.t} className="border hairline rounded-xl p-6 bg-white">
            <div className="w-8 h-8 rounded-full border border-[#B8860B] flex items-center justify-center gold-text font-serif mb-3">✦</div>
            <div className="font-serif text-lg mb-1">{v.t}</div>
            <div className="text-sm text-muted-foreground">{v.b}</div>
          </div>
        ))}
      </div>

      <div className="mt-14 border-t hairline pt-8 text-center">
        <div className="text-xs uppercase tracking-[0.3em] text-muted-foreground mb-3">Visit the store</div>
        <div className="font-serif text-2xl mb-4">Discover the AdiYogi Handcrafts collection</div>
        <Link to="/shop" className="btn-gold rounded-full px-8 py-3 text-xs uppercase tracking-widest" data-testid="about-shop-cta">Shop Collection</Link>
      </div>
    </div>
  );
}
